import classNames from 'classnames';
import React, { ReactElement } from 'react';
import { Label } from 'semantic-ui-react';

import css from './TagTabs.less';

type TabItem = {
  name: string;
  id: string;
  component: ReactElement;
};
interface TabsProps {
  tabs: TabItem[];
  activeTab: string | number;
  onChangeTab: (tab: string | number) => void;
}

const Tabs = ({ tabs, activeTab, onChangeTab }: TabsProps) => {
  const tabClassName = (tabId: number | string): string =>
    classNames([css.tab], { [css.active]: tabId === activeTab });
  return (
    <div className={css.container}>
      <div className={css.tabs}>
        {tabs.map(tab => (
          <div key={tab.id} onClick={() => onChangeTab(tab.id)} className={tabClassName(tab.id)}>
            <Label
              size="large"
              circular
              style={{ backgroundColor: tab.id === activeTab && '#30A1F9' }}>
              {tab.name}
            </Label>
          </div>
        ))}
      </div>
      <div className={css.tabContent}>
        {tabs.map(tab => (tab.id === activeTab ? tab.component : <div />))}
      </div>
    </div>
  );
};

export default Tabs;
